import { cn } from 'lib/cn';

const SIZES = {
  sm: 'h-4 w-4',
  md: 'h-5 w-5',
  lg: 'h-8 w-8',
};

/** Indeterminate loading spinner. Inherits color via `currentColor`. */
export function Spinner({ size = 'md', className }) {
  return (
    <svg
      className={cn('animate-spin', SIZES[size], className)}
      viewBox="0 0 24 24"
      fill="none"
      role="status"
      aria-label="Loading"
    >
      <circle className="opacity-20" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
      <path
        className="opacity-90"
        fill="currentColor"
        d="M12 2a10 10 0 0 1 10 10h-4a6 6 0 0 0-6-6z"
      />
    </svg>
  );
}

export default Spinner;
